import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const idUploadDetailsApi = createApi({
  reducerPath: 'idUploadDetailsApi',
  baseQuery: createBaseQuery('id_upload_details'),
  endpoints: builder => ({
    updateIdUploadDetail: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useUpdateIdUploadDetailMutation } = idUploadDetailsApi;
